export const CERTIFICATE_WORKFLOW_STATUS = {
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
} as const;

export type CertificateWorkflowStatus =
  (typeof CERTIFICATE_WORKFLOW_STATUS)[keyof typeof CERTIFICATE_WORKFLOW_STATUS];

export const CERTIFICATE_WORKFLOW_STATUS_VALUES = Object.values(
  CERTIFICATE_WORKFLOW_STATUS,
) as [CertificateWorkflowStatus, ...CertificateWorkflowStatus[]];

export const CERTIFICATE_WORKFLOW_STEPS = {
  EXTRACTION: 'EXTRACTION',
  CLASSIFICATION: 'CLASSIFICATION',
  FIELD_EXTRACTION: 'FIELD_EXTRACTION',
} as const;

export const CERTIFICATE_WORKFLOW_JOB_NAMES = {
  PROCESS: 'certificate_ai:process',
  CLASSIFICATION: 'certificate_ai:classification',
  FIELD_EXTRACTION: 'certificate_ai:field_extraction',
} as const;
